import { Pagination as MantinePagination } from "@mantine/core";

export const Pagination = MantinePagination;
